import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { supabase } from "../services/supabaseClient";

/**
 * Completes regulatory address registration once the email-verification
 * flow yields the correct authenticated account. Never sends residential
 * addresses through broad profile selects, auth user_metadata, or a JWT.
 *
 * An out-of-band email verification on another device cannot recover
 * sessionStorage; existing users can provide the address on My Profile.
 */
export default function RegulatoryResidenceSync() {
  const { user, authReady } = useAuth();

  useEffect(() => {
    if (!authReady || !user?.id || !user?.email) return undefined;
    let staged;
    try {
      staged = JSON.parse(sessionStorage.getItem("pending_ehailing_residence_v1") || "null");
    } catch {
      return undefined;
    }
    if (!staged || !staged.email || !staged.address) return undefined;
    if (String(staged.email).toLowerCase().trim() !== String(user.email).toLowerCase().trim()) return undefined;

    let active = true;
    const persist = async () => {
      const address = String(staged.address).trim();
      if (address.length < 10 || address.length > 600) return;
      const { data, error } = await supabase.rpc("save_my_ehailing_residence_v1", {
        p_residential_address: address,
        p_source: "signup_completion",
      });
      if (!active || error || !data?.ok) return;
      // Never delete a newer registration's staged address.
      try {
        const current = JSON.parse(sessionStorage.getItem("pending_ehailing_residence_v1") || "null");
        if (current?.email === staged.email && current?.address === staged.address) {
          sessionStorage.removeItem("pending_ehailing_residence_v1");
        }
      } catch { /* Keep the latest client-side draft for manual recovery. */ }
    };
    void persist();
    return () => { active = false; };
  }, [authReady, user?.id, user?.email]);

  return null;
}
